import { useContext } from 'react'

import { RailgunContext } from '@web/contexts/railgunContext'

export default function useRailgunContext() {
  const context = useContext(RailgunContext)

  if (!context) {
    throw new Error('useRailgunContext must be used within a RailgunContextProvider')
  }

  return context
}
